declare const process: { env: { REACT_APP_ENVIRONMENT?: string } };

const EXCLUDED_ROUTES = ['/reset-password'];

export function initTracking(): void {
    if (process.env.REACT_APP_ENVIRONMENT !== 'prod') return;
    if (EXCLUDED_ROUTES.includes(window.location.pathname)) return;

    // Google Ads / GA4
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-7L2HXJ80CQ';
    document.head.appendChild(gtagScript);

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).gtag = function () {
        (window as any).dataLayer.push(arguments);
    };
    (window as any).gtag('js', new Date());
    (window as any).gtag('config', 'AW-1071933170');
    (window as any).gtag('config', 'G-7L2HXJ80CQ', {
        transport_url: 'https://ssgtm.ssc-app-services.com',
        first_party_collection: true
    });

    // Profitwell — the SDK reads its token from data-pw-auth on the #profitwell-js element
    const PW_AUTH = '8f31ef1e7705ac68fac2fe2419a49511';

    (window as any).profitwell =
        (window as any).profitwell ||
        function (...args: any[]) {
            ((window as any).profitwell.q = (window as any).profitwell.q || []).push(args);
        };

    const pwPlaceholder = document.createElement('script');
    pwPlaceholder.id = 'profitwell-js';
    pwPlaceholder.dataset.pwAuth = PW_AUTH;
    document.head.appendChild(pwPlaceholder);

    const pwScript = document.createElement('script');
    pwScript.async = true;
    pwScript.src = `https://public.profitwell.com/js/profitwell.js?auth=${PW_AUTH}`;
    document.head.appendChild(pwScript);

    (window as any).profitwell('start', {});

    // Reddit Pixel
    (window as any).rdt = (window as any).rdt || function (...args: any[]) {
        const p = (window as any).rdt;
        p.sendEvent ? p.sendEvent.apply(p, args) : p.callQueue.push(args);
    };
    (window as any).rdt.callQueue = (window as any).rdt.callQueue || [];

    const rdtScript = document.createElement('script');
    rdtScript.async = true;
    rdtScript.src = 'https://www.redditstatic.com/ads/pixel.js?pixel_id=a2_j06pryw0d13z';
    document.head.appendChild(rdtScript);

    (window as any).rdt('init', 'a2_j06pryw0d13z');
    (window as any).rdt('track', 'PageVisit');

    // Bing UET
    (window as any).uetq = (window as any).uetq || [];
    (window as any).uetq.push('consent', 'default', { ad_storage: 'granted' });

    const uetScript = document.createElement('script');
    uetScript.async = true;
    uetScript.onload = () => {
        new (window as any).UET({ ti: '5318140', enableAutoSpaTracking: true, q: (window as any).uetq });
        (window as any).uetq.push('pageLoad');
    };
    uetScript.src = 'https://bat.bing.net/bat.js';
    document.head.appendChild(uetScript);
}
